import { LanguageType } from '@/__generated__/gateway/graphql';
import { mutateUserPatternSave } from '@/shared/graphql/gateway/mutations';
import { getApolloClients } from '@/shared/utils/apollo-client';
import { notifyBugsnagWithContext } from '@/shared/utils/error';

export class StashApiService {
  /**
   * Saves a pattern to the authenticated user's stash.
   * @param sku - Pattern product SKU
   * @param locale - Language for the pattern (use getLanguageType to derive from Shopify locale)
   * @returns Promise resolving to true on success, false on userErrors or network error (errors are reported to Bugsnag)
   */
  static async savePattern(
    sku: string,
    locale: LanguageType
  ): Promise<boolean> {
    try {
      const { gateway } = await getApolloClients();
      const result = await gateway.mutate(
        mutateUserPatternSave({ locale, sku })
      );
      const userErrors =
        result.data?.crafter?.userPatternSave?.userErrors ?? [];

      if (userErrors.length > 0) {
        notifyBugsnagWithContext(
          'StashApiService.savePattern',
          new Error(userErrors[0] ?? 'userPatternSave userErrors'),
          {
            message: 'userPatternSave returned userErrors',
            data: { productSku: sku, userErrors }
          }
        );
        return false;
      }

      return true;
    } catch (error) {
      notifyBugsnagWithContext('StashApiService.savePattern', error, {
        message: 'userPatternSave mutation failed',
        data: { productSku: sku }
      });
      return false;
    }
  }
}
